import React from 'react';
import { BaseComponent } from '../BaseComponent.js';
import FontAwesome from 'react-fontawesome';
import { GithubPicker } from 'react-color';

export default class DashboardAddModule extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false,
      graphData: this.props.graphData,
      editModule: this.props.editModule,
      modules: this.props.modules,
      title: '',
      error: '',
    };

    this.addGraph = this.addGraph.bind(this);
    this.openOverlay = this.openOverlay.bind(this);
    this.closeOverlay = this.closeOverlay.bind(this);
    this.renderOverlayAddModule = this.renderOverlayAddModule.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.editModule !== this.state.editModule) {
      this.checkEdit(props.editModule);
    }
    if (props.graphData !== this.state.graphData) {
      this.setState({ graphData: this.props.graphData });
    }
  }

  checkEdit(editModule) {
    if (editModule.id) {
      let i = 0;
      let keyIeeeAddress = [];
      let keys = [];
      let colors = [];
      while (i < editModule.data.length) {
        let d = editModule.data[i];
        if (d.key) {
          keys.push(d.key);
          colors[d.key] = d.color;
        } else if(d.IEEEAddress) {
          keyIeeeAddress.push(d.IEEEAddress + '_' + d.name);
          colors[d.IEEEAddress + '_' + d.name] = d.color;
        }
        i++;
      }

      let j = 0;
      let graphData = this.state.graphData;
      while (j < graphData.length) {
        let gd = graphData[j];
        if ((gd.key && keys.indexOf(gd.key) !== -1) || (gd.IEEEAddress && keyIeeeAddress.indexOf(gd.IEEEAddress + '_' + gd.name) !== -1)) {
          graphData[j].added = true;
          if (gd.key) {
            graphData[j].color = colors[gd.key];
          } else if(gd.IEEEAddress) {
            graphData[j].color = colors[gd.IEEEAddress + '_' + gd.name];
          }
        }
        j++;
      }

      this.setState({
        title: editModule.title,
        showOverlay: true,
        editModule: editModule,
        graphData: graphData,
      });
    }
  }

  addGraph() {
    let error;

    let dataAdded = [];
    if (this.state.graphData) {
      let i = 0;
      let added = 0;
      while (i < this.state.graphData.length) {
        if (this.state.graphData[i].added) {
          dataAdded.push(this.state.graphData[i]);
          added++;
        }
        i++;
      }
      if (added === 0) {
        error = 'Aggiungi dei dati';
      }
    }

    this.setState({ error: error });

    if (!error) {
      let modules = this.props.modules;
      if (this.state.editModule.id) {
        let i = 0;
        while (i < modules.length) {
          if (modules[i].id === this.state.editModule.id) {
            modules[i].data = dataAdded;
            modules[i].title = this.state.title;
          }
          i++;
        }
      } else {
        let mod = {
          data: dataAdded,
          title: this.state.title,
        };
        let z = 0;
        let id = 0;
        while (z < modules.length) {
          if (id < modules[z].id) {
            id = modules[z].id;
          }
          z++;
        }
        id++;
        mod.id = id;
        modules.unshift(mod);
      }

      this.setState({ modules: modules });
      console.log(modules);
      this.closeOverlay();
      this.props.saveGraphsToDb(modules);
    }
  }

  moveToAdded(data) {
    let graphData = this.state.graphData;
    let i = 0;
    while (i < graphData.length) {
      if (graphData[i].IEEEAddress) {
        if (data.IEEEAddress === graphData[i].IEEEAddress) {
          data.added = true;
        }
      } else {
        if (data.key === graphData[i].key) {
          data.added = true;
        }
      }
      i++;
    }
    this.setState({ graphData: graphData });
  }

  moveToAvailable(data) {
    let graphData = this.state.graphData;
    let i = 0;
    while (i < graphData.length) {
      if (graphData[i].IEEEAddress) {
        if (data.IEEEAddress === graphData[i].IEEEAddress) {
          data.added = false;
        }
      } else {
        if (data.key === graphData[i].key) {
          data.added = false;
        }
      }
      i++;
    }
    this.setState({ graphData: graphData });
  }

  renderAllData() {
    if (this.state.graphData.length) {
      let dataToAdd = this.state.graphData.map((data) => {
        if (!data.added) {
          let key;
          if (data.IEEEAddress && data.endpointID) {
            key = data.type + '_' + data.endpointID + '_' + data.IEEEAddress;
          } else {
            key = data.key;
          }
          return(
            <div data-name={ data.type } className="choose-list__element__list__choice" key={ key } onClick={ () => { this.moveToAdded(data) } }>{ data.name }</div>
          );
        }
        return '';
      });
      return dataToAdd;
    }
    return '';
  }

  renderAddedData() {
    if (this.state.graphData.length) {
      let dataToAdd = this.state.graphData.map((data) => {
        if (data.added) {
          let key;
          if (data.IEEEAddress && data.endpointID) {
            key = data.type + '_' + data.endpointID + '_' + data.IEEEAddress;
          } else {
            key = data.key;
          }
          return(
            <div className="choose-list__element__list__choice" key={ key } onClick={ () => { this.moveToAvailable(data) } }>{ data.name }</div>
          );
        }
        return '';
      });
      return dataToAdd;
    }
    return '';
  }

  renderError() {
    if (this.state.error) {
      return(
        <div className="graph-error">{ this.state.error }</div>
      );
    }
  }

  renderClassChooseBlock(type) {
    return "choose__block";
  }

  changeColor(color, event, data) {
    let i = 0;
    let graphData = this.state.graphData;
    while (i < graphData.length) {
      if (graphData[i] === data) {
        graphData[i].color = color.hex;
      }
      i++;
    }
    this.setState({ graphData: graphData });
  }

  renderColors() {
    if (this.state.graphData.length) {
      let dataToAdd = this.state.graphData.map((data) => {
        if (data.added) {
          console.log(data);
          let key;
          if (data.IEEEAddress && data.endpointID) {
            key = data.type + '_' + data.endpointID + '_' + data.IEEEAddress + '_color';
          } else {
            key = data.key + '_color';
          }
          return(
            <div className="color-list__element" key={ key }>
              { data.name }
              <span style={{ backgroundColor: data.color }}></span>
              <GithubPicker
                width="412px"
                triangle="hide"
                onChange={ (color, event) => { this.changeColor(color, event, data) } }
              />
            </div>
          );
        }
        return '';
      });
      return dataToAdd;
    }
    return '';
  }

  renderOverlayAddModule() {
    if (this.state.showOverlay) {
      return (
        <div className="overlay">
          <div className="overlay__shadow" onClick={ this.closeOverlay }></div>
          <div className="overlay__content overlay__content--padded">
            <div className="add-module-title">
              <input type="text" value={ this.state.title } placeholder="Inserisci un titolo" onChange={ (e) => { this.setState({ title: e.target.value }); }} />
            </div>
            <div className="choose-list">
              <div className="choose-list__arrows">
                <div><FontAwesome name="arrow-right" /></div>
                <div><FontAwesome name="arrow-left" /></div>
              </div>
              <div className="choose-list__element">
                <div className="choose-list__element__title">Dati disponibili</div>
                <div className="choose-list__element__list">
                  { this.renderAllData() }
                </div>
              </div>
              <div className="choose-list__element">
                <div className="choose-list__element__title">Dati aggiunti</div>
                <div className="choose-list__element__list">
                  { this.renderAddedData() }
                </div>
              </div>
            </div>

            { this.renderColors() }

            <div className="button-choose-wrapper">
              <button onClick={ this.addGraph } className="button button-primary">SALVA</button>
              { this.renderError() }
            </div>

          </div>
        </div>
      );
    }
    return '';
  }

  closeOverlay() {
    let j = 0;
    let graphData = this.state.graphData;
    while (j < graphData.length) {
      graphData[j].added = false;
      j++;
    }

    this.setState({
      showOverlay: false,
      editModule: {},
      graphData: graphData,
    }, () => {
      this.props.removeEditModule();
    });
  }

  openOverlay() {
    this.setState({ showOverlay: true });
  }


  componentDidMount() {
  }

  render() {
    return (
      <div>
        <button className="button-top button button-primary" onClick={ this.openOverlay }>AGGIUNGI MODULO</button>
        { this.renderOverlayAddModule() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardAddModule.js